var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5H17C15.89 16.5 15.01 17.39 15.01 18.5L15 30.5C15 31.61 15.89 32.5 17 32.5H33C34.11 32.5 35 31.61 35 30.5V18.5C35 17.39 34.11 16.5 33 16.5ZM32 30.5H18C17.45 30.5 17 30.05 17 29.5V24.5H33V29.5C33 30.05 32.55 30.5 32 30.5ZM33 20.5H17V18.5H33V20.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.8f58c2f5f29486b05cece4263af9974b.svg";
export { ForwardRef as ReactComponent };